import { Pipe, PipeTransform } from '@angular/core';

import { formatRelativeDate } from '@innersight-os/shared/util';

@Pipe({
    name: 'relativeDate',
    standalone: false
})
export class RelativeDatePipe implements PipeTransform {
  transform(date: Date): string {
    return formatRelativeDate(date);
  }
}
